// LEGACY: Uses SCSS with CSS modules. New code should use @metarouter-private/mr-mui components instead.
// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';

import { MrDataTable, MrTableTitle } from '@ion/components';
import NoDataText from 'app/components/data-table/NoDataText';
import { useConsentCategoriesTableContext } from '../../context/consentCategoriesTableContext';

import { RowsActions } from '../rows-actions/RowsActions';
import styles from './consentCategoriesTable.module.scss';
import AddCategoryButton from './AddCategoryButton';
import useHasConsentModule from './useHasConsentModule';

const COLUMN_IDS = {
  CODE: 'code',
};

const columns = [
  {
    id: COLUMN_IDS.CODE,
    name: 'Category Code',
    selector: row => row.code,
    sortable: true,
  },
  {
    name: 'Category Name',
    selector: row => row.name,
  },
  {
    name: 'Actions',
    cell: row => <RowsActions rowInfo={row} />,
  },
];

export const ConsentCategoriesTable = () => {
  const { onOpenModal, consentCategories } = useConsentCategoriesTableContext();
  const hasConsentModule = useHasConsentModule();
  const emptyText = hasConsentModule
    ? 'No categories set, use the Add Category button to create one.'
    : 'Consent Enforcement has not been enabled for your organization. Please reach out to your customer success representative for more information.';

  const onAddCategory = () => {
    onOpenModal('addCategory');
  };

  return (
    <MrDataTable
      title={<MrTableTitle title="Consent Categories" titlePill={`${consentCategories?.length} Categories`} />}
      columns={columns}
      data={consentCategories}
      actions={<AddCategoryButton onAddCategory={onAddCategory} />}
      className={styles.table}
      noDataComponent={<NoDataText>{emptyText}</NoDataText>}
      defaultSortFieldId={COLUMN_IDS.CODE}
      defaultSortAsc
    />
  );
};
